import { render, staticRenderFns } from "./BasicButton.vue?vue&type=template&id=ed846ebc&"
import script from "./BasicButton.vue?vue&type=script&lang=js&"
export * from "./BasicButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports